// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Icon from './icon';

// Styles
import './loading.scss';

class Loading extends Component {
    state = {
        height: undefined,
    };

    getClass() {
        const {className, small} = this.props;
        return classnames(
            {
                loading: true,
                loading_small: small,
            },
            className
        );
    }

    calcOffsetHeight = loader => {
        const {height} = this.state;

        if (loader && loader.offsetParent) {
            const {scrollHeight} = loader.offsetParent;

            if (height && height !== scrollHeight) {
                this.setState({height});
            }
        }
    };

    render() {
        const {loading, progressText} = this.props;
        const {height} = this.state;

        return loading ? (
            <div className={this.getClass()} ref={this.calcOffsetHeight} style={{minHeight: height}}>
                <Icon className="loading--icon" fontAwesomeType="spinner" spin={true} />
                <span style={{marginLeft: 10}}>{progressText}</span>
            </div>
        ) : null;
    }
}

Loading.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    progressText: PropTypes.string,
    small: PropTypes.bool,
};

export default Loading;
